import styled from 'styled-components'

export const StParagraph = styled.p`
  font-size: 1.2rem;
`
